export default __webpack_public_path__ + "static/media/ic_colorFilter.e8fdfd4c.svg";